// extracted by mini-css-extract-plugin
export default {"tabTitle":"tab-title_tabTitle__d-hCP","removeLanguageBtn":"tab-title_removeLanguageBtn__X6H1-"};